/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connection_Settings_UnsupportedInputs */



/**
* | output |
* | --- |
* | "This space has no settings that can be changed here." |
*
* @param {Spaces_Connection_Settings_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connection_settings_unsupported = /** @type {((inputs?: Spaces_Connection_Settings_UnsupportedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connection_Settings_UnsupportedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für diesen Space gibt es hier keine Einstellungen, die geändert werden können.")
	return /** @type {LocalizedString} */ ("This space has no settings that can be changed here.")
});